import { Clear } from "@mui/icons-material";
import { Box } from "@mui/material";
import ContentNormal from "components/elements/ContentNormal";
import { AppContext } from "contexts/AppContext";
import { useContext } from "react";

export function FilterChip({label, onClear}){
  const { styleGuide } = useContext(AppContext)
  return (
    <Box display={'flex'} paddingX={2} paddingY={1} gap={1} borderRadius={'14px'} alignItems={'center'} sx={{backgroundColor: styleGuide.color3}}>
      <Box
        onClick={onClear}
        sx={{cursor: 'pointer'}}
      >
        <Clear />
      </Box>
      <Box marginTop={'1px'}>
        <ContentNormal>{label}</ContentNormal>
      </Box>
    </Box>
  )
}